// tpa-filter.component.ts
import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormsModule} from '@angular/forms';
import {TpaStatusFilter} from '../../../../models/tpa.enum';
import {TpaDetailsStateService} from "../../services/tpa-details-state.service";
import {TpaService} from "../../../../services/tpa.service";

@Component({
  selector: 'app-tpa-filter',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatTooltipModule,
    FormsModule
  ],
  templateUrl: './tpa-filter.component.html',
  styleUrls: ['./tpa-filter.component.scss']
})
export class TpaFilterComponent implements OnInit {
  protected readonly tpaStatusFilter = TpaStatusFilter;

  currentStatusFilter: TpaStatusFilter = this.tpaStatusFilter.All;

  private tpaService = inject(TpaService);
  private tpaDetailStateService = inject(TpaDetailsStateService);

  ngOnInit(): void {
    this.initStatusFilter();
  }

  onStatusFilterAction(statusFilter: TpaStatusFilter) {
    this.tpaDetailStateService.emitFilterChange({
      ...this.tpaDetailStateService.getFiltersValue(),
      status: statusFilter
    })
  }

  private initStatusFilter() {
    // Always default to "All" filter on initialization
    this.currentStatusFilter = this.tpaStatusFilter.All;
    this.onStatusFilterAction(this.tpaStatusFilter.All);
  }
}
